"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

import { css, sva } from "@/../styled-system/css";

import CheckIcon from "../../../public/CheckIcon";

const checkbox = sva({
  slots: ["root", "indicator"],
  base: {
    root: {
      height: "20px",
      width: "20px",
      flexShrink: "0",
      rounded: "md",
      borderWidth: "1px",
      borderColor: "gray.300",
      cursor: "pointer",
      _disabled: { cursor: "not-allowed", opacity: "0.5" },
      _hover: { backgroundColor: "brandBlue/20" },
      '&[data-state="checked"]': {
        backgroundColor: "brandBlue",
        _hover: {
          backgroundColor: "brandBlue",
        },
      },
    },
    indicator: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
});

const { root, indicator } = checkbox.raw();

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    css?: object;
  }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(cssProp, root);

  return (
    <CheckboxPrimitive.Root ref={ref} className={className} {...props}>
      <CheckboxPrimitive.Indicator className={css(indicator)}>
        <CheckIcon fill="white" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
